module.exports = __webpack_public_path__ + "img/2.ac0e24db.png";